import type { ParticipantNachversandResDto } from '@web/common';
import { BookableCard } from './BookableCard';
import { BookedCard } from './BookedCard';
import { MissedCard } from './MissedCard';

export const CurrentNachversand = ({
  current,
}: {
  current: ParticipantNachversandResDto['current'];
}) => {
  if (current?.state === 'BOOKED') {
    return <BookedCard appointment={current.appointment} />;
  }

  if (current?.state === 'MISSED') {
    return <MissedCard appointment={current.appointment} />;
  }

  return <BookableCard />;
};
